import React from 'react';
import { connect } from 'react-redux';
import { globalFieldLengths } from '@/constants/fields';
import DictionaryInput from '../../dictionaries/components/DictionaryInput';
import DictionaryFieldValue from './DictionaryFieldValue';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldDescriptionTableCell = ({
  canEdit,
  canRead,
  code,
  category,
  description,
  dictionaryUUID,
  exists,
  fieldUUID,
  isEditing,
  template,
  updateProperties,
}) => (
  <>
    {isEditing && (
    <DictionaryFieldContainer category={category} code={code} exists={exists} canRead={canRead} canEdit={canEdit}>
      <DictionaryInput
        fluid
        text={description}
        type="field.description"
        maxLength={globalFieldLengths.description}
        onChange={(value) => (
          updateProperties(category, code, dictionaryUUID, { description: value }, fieldUUID, template)
        )}
      />
    </DictionaryFieldContainer>
    )}
    {!isEditing && (
    <DictionaryFieldValue category={category} code={code} value={description} canRead={canRead} canEdit={canEdit} />
    )}
  </>
);

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldDescriptionTableCell);
